'use client';

import config from '@packages/config';
import { LocaleSwitchLink } from './IndividualLinks/LocaleSwitchLink.client';
import { AccountLink } from './IndividualLinks/AccountLink.client';
import { WishlistLink } from './IndividualLinks/WishlistLink.client';
import { BasketLink } from './IndividualLinks/BasketLink.client';
import { ServiceLink } from './IndividualLinks/ServiceLink.client';
import { PaybackLink } from './IndividualLinks/PaybackLink.client';
import { useIsCheckoutRoute } from '../DesktopSlots/Base/useIsCheckoutRoute';

export const MetaNavigationLinks = () => {
  const {
    headerSlots: { payback, localeSwitcher, joe, serviceApi },
  } = config;

  // TODO handle differently at some point, to make this RSC-compatible
  const isCheckoutRoute = useIsCheckoutRoute();

  return (
    <div className="lg:hidden">
      <ul className="pt-[2px]">
        {localeSwitcher && <LocaleSwitchLink />}
        <AccountLink />
        <WishlistLink />
        {!isCheckoutRoute && <BasketLink />}
        {serviceApi && <ServiceLink />}
        {payback && <PaybackLink />}
      </ul>
    </div>
  );
};
